import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import MyImagePreview from '../myImagePreview/MyImagePreview';
import HnWNumpadModal from '../../hnWNumpadModal/HnWNumpadModal';
import AndroidUploadPicker from '../androidUploadPicker/AndroidUploadPicker';
import {
  checkIsIOS,
  getCurrentDateTimeStamp,
  getSplitText,
  thaiDate,
} from '../../../utill.func';
import { Upload, message } from 'antd';
import commonConstant, {
  ANDROID_CAMERA_PAGE_CANCEL_BTN,
  BUTTON_TAGNAME,
  CAMERA_FLOW_TYPE,
} from '../../commonConstant';
import {
  CHALLENGE_30_IMAGES,
  IMAGE_UPLOAD_ID,
  IMAGE_UPLOAD_INDEX_ARR,
  IMAGE_UPLOAD_LOADING_STATE,
  IMAGE_UPLOAD_PROPS,
  PERSONAL_MEMBER_PICTURE_MAP,
  PICTURE_TYPE_LOCALSTORAGE,
  REDIRECTION_URI,
  IMAGE_UPLOAD_INDEX_ARR_2026
} from '../../challengeConstants';
import {
  getLocalStorage,
  setLocalStorage,
} from '../../../services/promotion/utils.service';
import { useDispatch, useSelector } from 'react-redux';
import LoadingOverlay from 'react-loading-overlay';
import { Camera } from './camera/Camera';
import {
  getChallengeImagesAction,
  postChallenge30DaysUploadAction,
} from '../../../actions/challenge/challengeImageUploadActions';
import moment from 'moment';
import './CommonAndroidWrapper.scss';
import { ASSESSMENT_IMAGE_UPLOAD_PROPS, SKIN_ASM_CONSTANTS } from '../../skinAssessmentConstant';

const convertBlobToBinaryString = (blobFile, callbackBinaryString) => {
  const reader = new FileReader();
  reader.readAsArrayBuffer(blobFile);
  reader.onloadend = () => callbackBinaryString(reader.result);
};

const image64ToImage = (base64) => new Promise((resolve, reject) => {
  const img = new Image();
  img.src = base64;
  img.onload = () => resolve(img);
  img.onerror = () => reject(img);
});

const cropImage = (image, x, y, newWidth, newHeight) => {
  const canvas = document.createElement('canvas');
  canvas.width = newWidth;
  canvas.height = newHeight;
  const ctx = canvas.getContext('2d');

  ctx.drawImage(image, x, y, newWidth, newHeight, 0, 0, newWidth, newHeight);
  return canvas.toDataURL('image/jpeg', 0.5);
};

const cropImage64 = async (base64, x, y, newWidth, newHeight) => {
  const img = await image64ToImage(base64);
  return cropImage(img, x, y, newWidth, newHeight);
};

const getCameraFlow = async (componentInstance) => {
  if (componentInstance !== CAMERA_FLOW_TYPE.CAMERA) {
    return componentInstance === SKIN_ASM_CONSTANTS.ASSESSMENT_INSTANCE ? CAMERA_FLOW_TYPE.ASSESSMENT : CAMERA_FLOW_TYPE.CHALLENGE;
  }
  const propsString = await getLocalStorage(ASSESSMENT_IMAGE_UPLOAD_PROPS);
  if (propsString) { return CAMERA_FLOW_TYPE.ASSESSMENT; }

  return CAMERA_FLOW_TYPE.CHALLENGE;
};

const DEFAULT_CROP = { x: 0, y: 0 };
const DEFAULT_ZOOM = 1;
const DEFAULT_IMAGE_PROPS = {
  width: 0,
  height: 0,
  aspect: 0.75,
  containerHeight: 500,
};
export const Challenge2026AndroidWrapper = forwardRef(
  (
    {
      imageRef,
      componentInstance,
      onAssessmentImageConfirm,
      onAssessmentImageCancel,
      assessmentLabel,
      photos,
      setPhotos,
      eventId,
      partyId,
      aboId,
      userId,
      redirectionEventIdQuery,
      setPhotosLoading,
      setDatetimeThaiObj,
    },
    ref,
  ) => {
    const camera = useRef(null);

    const dispatch = useDispatch();
    const { images: s3ImagesStore } = useSelector(
      (state) => state.challengeImageUpload,
    );

    const [uploadId, setUploadId] = useState('');
    const [previewBlob, setPreviewBlob] = useState(null);
    const [fileInfo, setFileInfo] = useState(null);
    const [activePosition, setActivePosition] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPicker, setShowPicker] = useState(null);
    const [flash, setFlash] = useState(false);
    const [crop, setCrop] = useState(DEFAULT_CROP);
    const [zoom, setZoom] = useState(DEFAULT_ZOOM);
    const [coord, setCoord] = useState(null);
    const [fromGallery, setFromGallery] = useState(false);
    const [imageProperties, setImageProperties] = useState(DEFAULT_IMAGE_PROPS);

    useEffect(() => {
      fetchFromStorage();
    }, []);

    useEffect(() => {
      if (componentInstance === SKIN_ASM_CONSTANTS.ASSESSMENT_INSTANCE) { return; }

      if (eventId && userId) {
        getChallengeUserImages(eventId, userId);
      }
    }, [eventId, userId, componentInstance]);

    useEffect(() => {
      if (componentInstance === SKIN_ASM_CONSTANTS.ASSESSMENT_INSTANCE) { return; }

      if (s3ImagesStore.length > 0) {
        onMountHandler(s3ImagesStore ?? {});
      }
    }, [s3ImagesStore]);

    const fetchFromStorage = async () => {
      const imagesFromStorage = await getLocalStorage(CHALLENGE_30_IMAGES);

      if (imagesFromStorage) {
        setPhotos(JSON.parse(imagesFromStorage));
      }
    };

    const getChallengeUserImages = async (eventId, userId) => {
      try {
        setLoading(true);
        await dispatch(
          getChallengeImagesAction({
            eventId,
            userId,
            scoreId: null,
          }),
        );
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    const handleImageUpload = async (photoPosition) => {
      const uploadPropsString = await getLocalStorage(ASSESSMENT_IMAGE_UPLOAD_PROPS);
      const uploadProps = uploadPropsString ? JSON.parse(uploadPropsString) : null;

      const isAssessment = componentInstance === SKIN_ASM_CONSTANTS.ASSESSMENT_INSTANCE || uploadProps?.source === SKIN_ASM_CONSTANTS.ASSESSMENT_KEY;
      if (isAssessment) {
        if (checkIsIOS()) {
          const onClickCallback = imageRef?.current?.upload?.uploader?.onClick;
          onClickCallback({
            target: {
              tagName: BUTTON_TAGNAME,
              blur: () => { },
            },
          });
        } else {
          setShowPicker(true);
        }
        return;
      }

      if (!photoPosition) { return; }
      setUploadIdHandler(photoPosition);
      setActivePosition(photoPosition);
      if (checkIsIOS()) {
        const onClickCallback = imageRef?.current?.upload?.uploader?.onClick;
        onClickCallback({
          target: {
            tagName: BUTTON_TAGNAME,
            blur: () => { },
          },
        });
      } else {
        setShowPicker(photoPosition);
      }
    };

    useImperativeHandle(ref, () => ({
      handleImageUpload,
      onMountHandler,
    }));

    const onMountHandler = (challengeImages) => {
      if (!Array.isArray(challengeImages)) return;

      const photosObj = {
        after_center: null,
        after_left: null,
        after_right: null,
      };

      challengeImages
        .flatMap((item) => item.userUploads || [])
        .forEach((upload) => {
          if (!upload.path) return;

          let photoKey = "";

          switch (upload.upload_index) {
            case 1:
              photoKey = "after_center";
              break;

            case 2:
              photoKey = "after_left";
              break;

            case 3:
              photoKey = "after_right";
              break;

            default:
              return;
          }

          photosObj[photoKey] = upload.url ;
        });

      setPhotos(photosObj);
    };

    const retakeCallback = async () => {
      const flowType = await getCameraFlow(componentInstance);

      if (flowType === CAMERA_FLOW_TYPE.ASSESSMENT) {
        setPreviewBlob(null);
        setFileInfo(null);
        setZoom(DEFAULT_ZOOM);
        handleImageUpload();
        return;
      }
      if (componentInstance === CAMERA_FLOW_TYPE.CAMERA) {
        const photoPosition = await getLocalStorage(PICTURE_TYPE_LOCALSTORAGE);
        handleImageUpload(photoPosition);
      } else {
        handleImageUpload(activePosition);
      }
    };

    const previewHandler = (type, event) => {
      switch (type) {
        case 'onChange':
          setPreviewBlob(URL.createObjectURL(event.file.originFileObj));
          setFileInfo(event.file.originFileObj);
          break;
        case 'onClose':
        default:
          setPreviewBlob(null);
          setFileInfo(null);
          break;
      }
    };

    const beforeUpload = (file) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.addEventListener('load', event => {
        const _loadedImageUrl = event.target.result;
        const image = document.createElement('img');
        image.src = _loadedImageUrl;
        image.addEventListener('load', () => {
          const { width, height } = image;
          if (height > width) {
            const cropperAspect = parseFloat((width / height).toFixed(2));
            const imageProps = {
              width,
              height,
              aspect: Math.min(DEFAULT_IMAGE_PROPS.aspect, cropperAspect),
              containerHeight: cropperAspect <= 0.6 ? 650 : 500,
            };
            setImageProperties(imageProps);
          }
        });
      });
      const isLessThan1MB = file.size / 1024 / 1024 < 1;
      if (isLessThan1MB) {
        message.error('Image must be greater than 1 MB');
        return Upload.LIST_IGNORE;
      }

      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      return isJpgOrPng;
    };

    const handleAndroidPicker = (type) => {
      switch (type) {
        case 'takePhoto':

          // don't reload the same URL (avoids the camera-release race).
          if (componentInstance === CAMERA_FLOW_TYPE.CAMERA) {
            setCrop(DEFAULT_CROP);
            setZoom(DEFAULT_ZOOM);
            setCoord(null);
            setShowPicker(null);
            setPreviewBlob(null);
            setFileInfo(null);
            return;
          }

          if (
            ['PICTURE_PAGE', 'PICTURE_COMPONENT'].includes(componentInstance)
          ) {
            setLocalStorage(PICTURE_TYPE_LOCALSTORAGE, activePosition);
            setLocalStorage(
              REDIRECTION_URI,
              commonConstant.pathChallengeMyWeightout,
            );
            setLocalStorage(
              IMAGE_UPLOAD_PROPS,
              JSON.stringify({
                eventId,
                partyId,
                aboId,
                userId,
                redirectionEventIdQuery,
              }),
            );
            setLocalStorage(
              IMAGE_UPLOAD_ID,
              setUploadIdHandler(activePosition),
            );
            setLocalStorage(CHALLENGE_30_IMAGES, JSON.stringify(photos));
          }
          setCrop(DEFAULT_CROP);
          setZoom(DEFAULT_ZOOM);
          setCoord(null);
          setShowPicker(null);
          setPreviewBlob(null);
          setFileInfo(null);
          window.location.href = process.env.REACT_APP_CHALLENGE_CAMERA_LIFF_URL;
          break;
        case 'uploadPhoto':
        default:
          setFromGallery(true);
          if (componentInstance === SKIN_ASM_CONSTANTS.ASSESSMENT_INSTANCE) {
            setLocalStorage(
              IMAGE_UPLOAD_PROPS,
              JSON.stringify({
                source:
                  SKIN_ASM_CONSTANTS.ASSESSMENT_KEY,
                assessmentLabel,
              }),
            );
          }

          const onClickCallback = imageRef?.current?.upload?.uploader?.onClick;
          onClickCallback({
            target: {
              tagName: BUTTON_TAGNAME,
              blur: () => { },
            },
          });
          setCrop(DEFAULT_CROP);
          setZoom(DEFAULT_ZOOM);
          setCoord(null);
          setShowPicker(null);
          break;
      }
    };

    const setUploadIdHandler = (photoPosition) => {
      const uploadIndex = parseInt(
        IMAGE_UPLOAD_INDEX_ARR_2026.indexOf(photoPosition) + 1,
      );
      const userUpload = s3ImagesStore
        .flatMap((image) => image?.userUploads)
        .find((upload) => upload?.upload_index === uploadIndex);
      if (userUpload?.id) {
        setUploadId(userUpload.id);
        return userUpload.id;
      }
      return null;
    };

    const blobToFile = (blob) => new File([blob],
      `weightout30_days_${Date.now()}.jpg`,
      { type: blob.type || 'image/jpeg' },
    );

    const uploadCallback = async () => {
      await getCameraFlow(componentInstance);

      if (!coord) return;  //crop rect not ready, don't proceed
      // CHALLENGE UPLOAD FUNCTIONALITY
      setLoading(true);


      try {
        const croppedImage = await cropImage64(
          previewBlob,
          coord.x,
          coord.y,
          coord.width,
          coord.height,
        );
        const response = await fetch(croppedImage);
        const blobImage = await response.blob();
        let uId = uploadId;
        let isBeforeAfter;
        let postCompetition;
        if (componentInstance === 'CAMERA') {
          const imageUploadId = await getLocalStorage(IMAGE_UPLOAD_ID);
          const pictureType = await getLocalStorage(PICTURE_TYPE_LOCALSTORAGE);
          isBeforeAfter = getSplitText(pictureType, 0, '_');
          postCompetition = getSplitText(pictureType, 1, '_');
          uId = imageUploadId;
        } else {
          setPhotosLoading({
            ...IMAGE_UPLOAD_LOADING_STATE,
            [activePosition]: true,
          });
          uId = uploadId;
          isBeforeAfter = getSplitText(activePosition, 0, '_');
          postCompetition = getSplitText(activePosition, 1, '_');
          setShowPicker(null);
          setPreviewBlob(null);
          setFileInfo(null);
        }
        if (blobImage) {
          const fileExtention =
            getSplitText(blobImage.type, 1, "/") || "png";

          const fileName = `beforeafter/${partyId}/${isBeforeAfter}/${aboId}_${partyId}_${postCompetition}_${getCurrentDateTimeStamp()}.${fileExtention}`;
          await new Promise((resolve, reject) => {
            convertBlobToBinaryString(blobImage, async (binaryString) => {
              try {
                const payload = {
                  eventId: eventId,
                  partyId: partyId,
                  fileName,
                  contentType: blobImage.type,
                  file: blobToFile(binaryString),
                  approveStatus: 'APPROVED',
                  fileDesc: fileName,
                  uploadId: uId,
                  uploadDate: moment().format('yyyy-MM-DD'),
                  createdAt: moment().format('yyyy-MM-DD'),
                };

                const result = await dispatch(
                  postChallenge30DaysUploadAction(payload, activePosition)
                );

                const uploadedImagesJSON = await getLocalStorage(
                  CHALLENGE_30_IMAGES
                );

                const uploadedImagesObj = JSON.parse(
                  uploadedImagesJSON || "{}"
                );

                await setLocalStorage(
                  CHALLENGE_30_IMAGES,
                  JSON.stringify({
                    ...uploadedImagesObj,
                    [`${isBeforeAfter}_${postCompetition}`]:
                      `${process.env.REACT_APP_S3_LINEX_BUCKET}${result}`,
                  })
                );

                if (componentInstance === "CAMERA") {
                  const redirectToPath = await getLocalStorage(
                    REDIRECTION_URI
                  );

                  window.location.href = `https://${window.location.host}${redirectToPath}?eventId=${redirectionEventIdQuery}&partyId=${partyId}&challengeId=${eventId}&scrollTo=imageCardSection&aboId=${aboId}`;
                } else {
                  await getChallengeUserImages(eventId, userId);
                }

                resolve();
              } catch (err) {
                reject(err);
              }
            });
          });
        } else {
          setLoading(false);
          if (componentInstance !== 'CAMERA') {
            setPhotosLoading(IMAGE_UPLOAD_LOADING_STATE);
          }
        }
      } catch (error) {
        console.error("Error in upload callback in Challenge 2026 android warrper : ", error)
      } finally {
        setLoading(false);  
        if (componentInstance !== 'CAMERA') {
          setPhotosLoading(IMAGE_UPLOAD_LOADING_STATE);
        }
      }
    };
    const handleCancelBtn = async () => {
      const flowType = await getCameraFlow(componentInstance);

      if (flowType === CAMERA_FLOW_TYPE.ASSESSMENT) {
        const propsUploadString = await getLocalStorage(ASSESSMENT_IMAGE_UPLOAD_PROPS);
        const propsUpload = JSON.parse(propsUploadString);
        if (!propsUpload) { return; }
        localStorage.removeItem(ASSESSMENT_IMAGE_UPLOAD_PROPS);
        window.location.href = propsUpload.redirectPath;
        return;
      }

      const redirectToPath = await getLocalStorage(REDIRECTION_URI);
      window.location.href = `https://${window.location.hostname}${redirectToPath}?eventId=${redirectionEventIdQuery}&partyId=${partyId}&challengeId=${eventId}&aboId=${aboId}`;
    };

    const handleZoom = async (zoomValue) => {
      const currentTime = new Date().getTime();
      if (componentInstance === CAMERA_FLOW_TYPE.CAMERA) {
        const isCameraFromAssessment = await getLocalStorage(ASSESSMENT_IMAGE_UPLOAD_PROPS);
        if (isCameraFromAssessment && !fromGallery) { return; }
      }

      if (checkIsIOS() && componentInstance === SKIN_ASM_CONSTANTS.ASSESSMENT_INSTANCE) {
        if (currentTime - fileInfo.lastModified < 60000) { return; }
      }
      setZoom(zoomValue);
    };

    const handleAssessmentCancel = () => {
      resetPreviewState();

      if (onAssessmentImageCancel) {
        onAssessmentImageCancel();
      }
    };

    const resetPreviewState = () => {
      setPreviewBlob(null);
      setFileInfo(null);
      setCrop(DEFAULT_CROP);
      setZoom(DEFAULT_ZOOM);
      setCoord(null);
    };

    const previewUploadCallback = uploadCallback;
    const previewCloseCallback = componentInstance === SKIN_ASM_CONSTANTS.ASSESSMENT_INSTANCE ? handleAssessmentCancel : () => previewHandler('onClose');

    return (
      <>
        {loading && componentInstance === 'CAMERA' ? (
          <LoadingOverlay text="Loading" active={loading} spinner={true} />
        ) : null}
        {componentInstance === 'CAMERA' ? (
          <>
            <Camera
              ref={camera}
              setImage={(bFile) => setPreviewBlob(URL.createObjectURL(bFile))}
              aspectRatio={3 / 5.5}
              facingMode="environment"
            />
            <div className="custom-android-camera-container-flash">
              <img
                src={`/images/challenge/myupload/${flash ? 'flashon' : 'flashoff'
                }.svg`}
                alt="flash.svg"
                onClick={() => {
                  const flashState = camera.current.toggleTorch();
                  setFlash(flashState);
                }}
              />
            </div>
            <div className="custom-android-camera-container-actions">
              <span
                className="custom-android-camera-container-actions-cancel"
                onClick={handleCancelBtn}
              >
                {ANDROID_CAMERA_PAGE_CANCEL_BTN}
              </span>
              <img
                src="/images/challenge/myupload/camera-click.svg"
                alt="camera-click.svg"
                onClick={() => camera.current.takePhoto('toBlob')}
              />
              <img
                src="/images/challenge/myupload/change-camera.svg"
                alt="change-camera.svg"
                onClick={() => camera.current.switchCamera()}
              />
            </div>
          </>
        ) : null}
        <div className="common-android-preview-height">
          {previewBlob ? (
            <HnWNumpadModal
              openNumpad={previewBlob}
              onBackgroundClick={() => previewHandler('onClose')}
            >
              <MyImagePreview
                crop={crop}
                setCrop={setCrop}
                zoom={zoom}
                setZoom={handleZoom}
                setCoord={setCoord}
                {...(componentInstance !== SKIN_ASM_CONSTANTS.ASSESSMENT_INSTANCE && {
                  activePosition:
                    PERSONAL_MEMBER_PICTURE_MAP[activePosition?.toUpperCase()],
                })}
                previewBlob={previewBlob}
                uploadCallback={previewUploadCallback}
                retakeCallback={retakeCallback}
                imageProperties={{ ...imageProperties, aspect: componentInstance === 'CAMERA' ? 3 / 5.5 : imageProperties.aspect }}
                closePreview={previewCloseCallback}
              />
            </HnWNumpadModal>
          ) : null}
        </div>
        <div className="common-android-picker-height">
          {showPicker ? (
            <HnWNumpadModal
              openNumpad={showPicker}
              onBackgroundClick={() => setShowPicker(null)}
            >
              <AndroidUploadPicker
                onCloseHandler={() => setShowPicker(null)}
                handleAndroidPicker={handleAndroidPicker}
              />
            </HnWNumpadModal>
          ) : null}
        </div>
        <Upload
          onChange={(event) => previewHandler('onChange', event)}
          className="display-none"
          name="myPhotoUpload"
          id="myPhotoUpload"
          ref={imageRef}
          accept={'image/png,image/jpeg,image/jpg'}
          openFileDialogOnClick={checkIsIOS()}
          beforeUpload={beforeUpload}
        />
      </>
    );
  },
);
